import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import Divider from '@material-ui/core/Divider'
import { makeStyles } from '@material-ui/core/styles'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import DeleteIcon from '@material-ui/icons/Delete'
import SaveAltIcon from '@material-ui/icons/SaveAlt'
import moment from 'moment'
import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import HeaderDetails from '../../components/HeaderDetails'
import { StoreState } from '../../store'
import { removePerson, savePerson } from '../../store/people/peopleActions'
import { PeopleActionTypes } from '../../store/people/peopleTypes'
import FormPeople from '../../types/FormPeople'
import PeopleTabAddress from './PeopleTabAddress'
import PeopleTabFamily from './PeopleTabFamily'
import PeopleTabMinistry from './PeopleTabMinistry'
import PeopleTabPersonal from './PeopleTabPersonal'

const useStyles = makeStyles((theme) => ({
  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  content: {
    height: '100%',
    overflowY: 'scroll',
    padding: theme.spacing(2),
  },
  input: {
    margin: theme.spacing(1),
  },
  marginRight: {
    marginRight: theme.spacing(1),
  },
}))

const emptyForm: FormPeople = {
  name: '',
  internalCode: '',
  phone: '',
  cellphone: '',
  gender: '',
  maritalStatus: '',
  birthday: '',
  nationality: '',
  schooling: '',
  native: '',
  rg: '',
  cpf: '',
  work: '',
  email: '',
  company: '',
  companyPhone: '',
  fatherName: '',
  motherName: '',
  spouseName: '',
  weddingDate: '',
  childrenQty: '',
  consecrated: '',
  consecratedMinistry: '',
  consecratedChurch: '',
  consecratedDate: '',
  baptismDate: '',
  leadershipMinistry: '',
  ministry: '',
  ministryDate: '',
  ministryMode: '',
  hadMembershipCard: '',
  membershipCardDate: '',
  obs: '',
  status: 'Ativo',
  address: {
    zipCode: '',
    street: '',
    number: '',
    complement: '',
    reference: '',
    neighborhood: '',
    city: '',
    state: '',
  },
  image: null,
}

export default function PeopleDetails() {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { savingPerson, removingPerson, isEditing, originalData } = useSelector(
    ({ peopleState }: StoreState) => ({
      savingPerson: peopleState.savingPerson,
      removingPerson: peopleState.removingPerson,
      isEditing: peopleState.selectedIndex !== null,
      originalData:
        peopleState.selectedIndex !== null
          ? peopleState.people[peopleState.selectedIndex]
          : null,
    })
  )

  const [tabIndex, setTabIndex] = useState(0)
  const [isOpenModalRemove, setOpenModalRemove] = useState(false)
  const openModalRemove = () => setOpenModalRemove(true)
  const closeModalRemove = () => setOpenModalRemove(false)

  const form = useForm<FormPeople>({
    defaultValues: !originalData
      ? emptyForm
      : {
          name: originalData.name,
          internalCode: originalData.internalCode,
          phone: originalData.phone,
          cellphone: originalData.cellphone,
          gender: originalData.gender || '',
          maritalStatus: originalData.maritalStatus || '',
          birthday: originalData.birthday
            ? moment(originalData.birthday, 'YYYY-MM-DD').format('DD/MM/YYYY')
            : '',
          nationality: originalData.nationality,
          schooling: originalData.schooling,
          native: originalData.native,
          rg: originalData.rg,
          cpf: originalData.cpf,
          work: originalData.work,
          email: originalData.email,
          company: originalData.company,
          companyPhone: originalData.companyPhone,
          fatherName: originalData.fatherName,
          motherName: originalData.motherName,
          spouseName: originalData.spouseName,
          weddingDate: originalData.weddingDate
            ? moment(originalData.weddingDate, 'YYYY-MM-DD').format(
                'DD/MM/YYYY'
              )
            : '',
          childrenQty: originalData.childrenQty?.toString() || '',
          consecrated: originalData.consecrated || '',
          consecratedMinistry: originalData.consecratedMinistry,
          consecratedChurch: originalData.consecratedChurch,
          consecratedDate: originalData.consecratedDate
            ? moment(originalData.consecratedDate, 'YYYY-MM-DD').format(
                'DD/MM/YYYY'
              )
            : '',
          baptismDate: originalData.baptismDate
            ? moment(originalData.baptismDate, 'YYYY-MM-DD').format(
                'DD/MM/YYYY'
              )
            : '',
          leadershipMinistry: originalData.leadershipMinistry,
          ministry: originalData.ministry,
          ministryDate: originalData.ministryDate
            ? moment(originalData.ministryDate, 'YYYY-MM-DD').format(
                'DD/MM/YYYY'
              )
            : '',
          ministryMode: originalData.ministryMode,
          hadMembershipCard: originalData.hadMembershipCard ? 'Sim' : 'Não',
          membershipCardDate: originalData.membershipCardDate
            ? moment(originalData.membershipCardDate, 'YYYY-MM-DD').format(
                'DD/MM/YYYY'
              )
            : '',
          obs: originalData.obs,
          status: originalData.status || 'Ativo',
          address: !originalData.address
            ? emptyForm.address
            : {
                zipCode: originalData.address.zipCode,
                street: originalData.address.street,
                number: originalData.address.number?.toString() || '',
                complement: originalData.address.complement,
                neighborhood: originalData.address.neighborhood,
                city: originalData.address.city,
                state: originalData.address.state,
              },
          image: originalData.image?.md || null,
        },
  })

  const onClose = () => {
    dispatch({ type: PeopleActionTypes.EDITING_CANCEL })
  }

  const onClickSave = async () => {
    await form.triggerValidation()
    if (form.errors.name) {
      setTabIndex(0)
      form.errors.name.ref.focus()
      return
    }
    if (form.errors.birthday || form.errors.membershipCardDate) {
      setTabIndex(0)
      return
    }
    if (form.errors.weddingDate) {
      setTabIndex(2)
      return
    }
    if (
      form.errors.consecratedDate ||
      form.errors.baptismDate ||
      form.errors.ministryDate
    ) {
      setTabIndex(3)
      return
    }
    const data = form.getValues({ nest: true })
    dispatch(savePerson(data))
    form.reset(emptyForm)
  }

  const onClickConfirmRemovePerson = () => {
    closeModalRemove()
    dispatch(removePerson())
  }

  return (
    <Box className={classes.container}>
      <HeaderDetails
        title={isEditing ? 'Editando cadastro' : 'Novo cadastro'}
        onClose={onClose}
      />
      <Tabs
        value={tabIndex}
        onChange={(e, value) => setTabIndex(value)}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
      >
        <Tab label="Dados pessoais" />
        <Tab label="Endereço" />
        <Tab label="Família" />
        <Tab label="Ministério" />
      </Tabs>

      <div className={classes.content}>
        <PeopleTabPersonal form={form} open={tabIndex === 0} />
        <PeopleTabAddress form={form} open={tabIndex === 1} />
        <PeopleTabFamily form={form} open={tabIndex === 2} />
        <PeopleTabMinistry form={form} open={tabIndex === 3} />
      </div>

      <Box>
        <Divider />
        <Box m={2}>
          <Button
            onClick={onClickSave}
            size="large"
            color="primary"
            variant="contained"
            disabled={savingPerson}
            className={classes.marginRight}
          >
            <SaveAltIcon className={classes.marginRight} />
            {savingPerson ? 'AGUARDE...' : 'SALVAR'}
          </Button>
          <Button
            onClick={openModalRemove}
            size="large"
            disabled={!isEditing}
            className={classes.marginRight}
          >
            <DeleteIcon className={classes.marginRight} />
            {removingPerson ? 'AGUARDE...' : 'EXCLUIR'}
          </Button>
        </Box>
      </Box>

      <Dialog open={isOpenModalRemove} onClose={closeModalRemove}>
        <DialogTitle>Excluir este cadastro?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Esta ação não poderá ser desfeita.
            <br />
            Tem certeza que deseja remover este cadastro?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            disabled={removingPerson}
            onClick={closeModalRemove}
            color="primary"
          >
            Não
          </Button>
          <Button
            disabled={removingPerson}
            onClick={onClickConfirmRemovePerson}
            color="primary"
            autoFocus
          >
            SIM
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  )
}
